<!--suppress ALL -->
<!--suppress ALL -->
<template>
  <detailTemplate
    :classCustom="[tabHistory ? 'detailShowHistory' : '', 'detail-docs']"
  >
    <template #content>
      <transition name="el-fade-in-linear">
        <el-tooltip content="Lịch sử tác động" placement="left">
          <div
            v-show="!tabHistory"
            class="btn-show-history clickable flex-row flex__center border-radius__50"
            @click="openTabHistory"
          >
            <el-badge class="inline-flex" is-dot>
              <i class="icon-small fal fa-comment-alt-smile"></i>
            </el-badge>
          </div>
        </el-tooltip>
      </transition>
      <i
        class="back-icon border-radius fal fa-arrow-right"
        @click="backListPage"
      ></i>
      <div class="header">
        <div class="docTags">
          <el-tag
            v-if="outgoingDoc.docTypeName"
            class="priority lv3"
            size="mini"
          >
            {{ outgoingDoc.docTypeName }}
          </el-tag>
          <el-tag
            v-if="outgoingDoc.priorityId"
            :class="['priority', `${getPriorityClass(outgoingDoc.priorityId)}`]"
            size="mini"
          >
            <i class="fas fa-bolt"></i>
            {{ outgoingDoc.priorityName }}
          </el-tag>
        </div>
        <h4 class="title-name">
          {{ outgoingDoc.quote }}
        </h4>

        <vbdi-download-files-for-config-ld
          :docId="id"
          :isConfigLD="true"
          :userDeptRoleId="userDeptRoleId"
        >
        </vbdi-download-files-for-config-ld>
        <div class="flex-row">
          <el-button v-if="vbAttachment&&vbAttachment.id" class="btnPlain"
                     @click="isOpenVbDiVersionDialog = true">
            <i class="fas fa-history"></i>
            &nbsp;Phiên bản văn bản dự thảo
          </el-button>
        </div>
      </div>

      <VuePerfectScrollbar :settings="settings" class="scroll-area">
        <div class="body">
          <div class="group__info margin-top-10 padding-bottom-10">
            <div class="title font-size__medium">Thông tin</div>
            <div class="ctn">
              <div class="list-info width__100">
                <div
                  v-if="outgoingDoc.docCode"
                  class="item flex-row flex__left margin-bottom-10"
                >
                  <div class="label font-size__small txt-right">
                    Số ký hiệu:
                  </div>
                  <div class="content width__100 has-border__bottom">
                    {{ outgoingDoc.docCode || "-" }}
                  </div>
                </div>
                <div
                  v-if="outgoingDoc.docDate"
                  class="item flex-row flex__left margin-bottom-10"
                >
                  <div class="label font-size__small txt-right">
                    Ngày văn bản:
                  </div>
                  <div class="content width__100 has-border__bottom">
                    {{
                      outgoingDoc.docDate
                        | dateFormatter({
                        nullValue: "-",
                        dateFormat: "DD/MM/YYYY"
                      })
                    }}
                  </div>
                </div>

                <div class="item flex-row flex__left margin-bottom-10">
                  <div class="label font-size__small txt-right">
                    Hạn xử lý:
                  </div>
                  <div class="content width__100 has-border__bottom">
                    {{
                      outgoingDoc.deadlineDate
                        | dateFormatter({
                        nullValue: "-",
                        dateFormat: "DD/MM/YYYY HH:mm"
                      })
                    }}
                  </div>
                </div>

                <div class="item flex-row flex__left margin-bottom-10">
                  <div class="label font-size__small txt-right">
                    Đơn vị ban hành:
                  </div>
                  <div class="content width__100 has-border__bottom">
                    {{outgoingDoc.publisherNameDetail}}
                    {{ outgoingDoc.publisherName || "-" }}
                  </div>
                </div>

                <div
                  v-if="
                    docStatus === OUTGOING_DOC_STATUS.CHO_BAN_HANH ||
                      docStatus === OUTGOING_DOC_STATUS.DABANHANH
                  "
                  class="item flex-row flex__left margin-bottom-10"
                >
                  <div class="label font-size__small txt-right">
                    Người ký duyệt:
                  </div>
                  <div class="content width__100 has-border__bottom">
                    {{ signerName || "-" }}
                  </div>
                </div>

                <div class="item flex-row flex__left margin-bottom-10">
                  <div class="label font-size__small txt-right">
                    Đơn vị thực hiện:
                  </div>
                  <div class="content width__100 has-border__bottom">
                    {{ outgoingDoc.deptEditorName || "-" }}
                  </div>
                </div>

                <div class="item flex-row flex__left margin-bottom-10">
                  <div class="label font-size__small txt-right">
                    Số trang/ Số bản:
                  </div>
                  <div class="content width__100 has-border__bottom">
                    {{ outgoingDoc.numberOfPage || "-" }} /
                    {{ outgoingDoc.numberOfCopy || "-" }}
                  </div>
                </div>

                <!--nơi nhận bên trong-->
                <div class="item flex-row flex__left margin-bottom-10">
                  <div class="label font-size__small txt-right">
                    Nơi nhận bên trong:
                  </div>
                  <div class="content width__100 has-border__bottom">
                    <p v-if="!docReceivers || !docReceivers.length">-</p>
                    <div v-else class="flex-col flex__left">
                      <p
                        v-for="docReceiver in docReceivers"
                        v-bind:key="docReceiver.id"
                        :class="[
                          'index' !== docReceivers.length - 1
                            ? 'margin-bottom-10'
                            : ''
                        ]"
                      >
                        {{ docReceiver.objectName }}
                      </p>
                    </div>
                  </div>
                </div>
                <!--nơi nhận bên trong:end-->

                <!--nơi nhận bên ngoài-->
                <div class="item flex-row flex__left margin-bottom-10">
                  <div class="label font-size__small txt-right">
                    Nơi nhận bên ngoài:
                  </div>
                  <div class="content width__100 has-border__bottom">
                    <!-- doi voi cac du lieu moi thi hien thi kieu nay-->
                    <div
                      v-if="receiveOtherDepts && receiveOtherDepts.length"
                      class="flex-col flex__left"
                    >
                      <p
                        v-for="receiveOtherDept in receiveOtherDepts"
                        :key="receiveOtherDept.id"
                        class="margin-bottom-10"
                      >
                        {{ receiveOtherDept.objectName }}
                      </p>
                    </div>
                    <!-- doi voi cac du lieu moi thi hien thi kieu nay:end-->
                    <!-- doi voi cac du lieu cu thi hien thi kieu nay-->
                    <div
                      v-else-if="outgoingDoc && outgoingDoc.otherReceivePlaces"
                      class="flex-col flex__left"
                    >
                      <p
                        v-for="otherReceivePlace in outgoingDoc.otherReceivePlaces.split(
                          ','
                        )"
                        :key="otherReceivePlace"
                        class="margin-bottom-10"
                      >
                        {{ otherReceivePlace || "-" }}
                      </p>
                    </div>
                    <!-- doi voi cac du lieu cu thi hien thi kieu nay:end-->
                    <p v-else class="txt__left">-</p>
                  </div>
                </div>
                <!--nơi nhận bên ngoài:end-->

                <!--nơi nhận trên trục liên thông-->
                <div
                  v-if="isBanHanhTrucLienThong"
                  class="item flex-row flex__left margin-bottom-10"
                >
                  <div class="label font-size__small txt-right">
                    Nơi nhận trên trục liên thông văn bản
                  </div>
                  <div class="content width__100 has-border__bottom">
                    <p v-if="!agencies || !agencies.length">-</p>
                    <div v-else class="flex-col flex__left">
                      <p
                        v-for="agency in agencies"
                        v-bind:key="agency.id"
                        :class="[
                          'index' !== agencies.length - 1
                            ? 'margin-bottom-10'
                            : ''
                        ]"
                      >
                        {{ agency.objectName }}
                      </p>
                    </div>
                  </div>
                </div>
                <!--nơi nhận trên trục liên thông:end-->

                <div
                  v-if="isBanHanhTrucLienThong"
                  class="item flex-row flex__left margin-bottom-10"
                >
                  <div class="label font-size__small txt-right">
                    Văn bản quy phạm pháp luật
                  </div>
                  <div class="content width__100 has-border__bottom">
                    <el-checkbox
                      v-model="isLawDocument"
                      :border="false"
                      :disabled="true"
                      class="style-fullWidth"
                    ></el-checkbox>
                  </div>
                </div>

                <div
                  v-if="isBanHanhTrucLienThong"
                  class="item flex-row flex__left margin-bottom-10"
                >
                  <div class="label font-size__small txt-right">
                    Loại chỉ đạo
                  </div>
                  <div class="content width__100 has-border__bottom">
                    {{ steeringTypeLabel || "-" }}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <doc-relations-detail
            :attached-type="DOC_RELATION_ATTACHED_TYPE.NO_ATTACHED"
            :doc-id="id"
            :title="'Văn bản liên quan không ban hành kèm'"
          ></doc-relations-detail>

          <doc-relations-detail
            :attached-type="DOC_RELATION_ATTACHED_TYPE.ATTACHED"
            :doc-id="id"
            :title="'Văn bản liên quan ban hành kèm'"
          ></doc-relations-detail>

          <phieu-y-kien-detail
            :doc-id="id"
            :title="'Phiếu ý kiến'"
          ></phieu-y-kien-detail>

          <vbdi-luongxuly-wrapper
            :id="id"
            :isConfigLD="true"
          />

          <vbdi-luongxuly-all
            v-if="openFlowDetail"
            :docId="id"
            :openFlowDetail="openFlowDetail"
            @closeDialog="openFlowDetail=false"
          />
        </div>
      </VuePerfectScrollbar>

      <div class="footer" style="overflow-x: scroll;">
        <div class="flex-row flex__left form-button__action">
          <el-button
            class="detailBtn detailBtnPrimary"
            @click="openFlowDetail = true"
          >
            <i class="fas fa-eye font-size__medium"></i>
            &nbsp;Phân luồng
          </el-button>
        </div>
      </div>

      <transition name="slide">
        <history-docout
          v-show="tabHistory"
          :isEnableComment="false"
          :vbOutgoingDocId="id"
          :isConfigLD="true"
          @closeHistory="closeTabHistory"
        ></history-docout>
      </transition>

      <!-- dialog chon nguoi xu ly -->
      <DocOutSelectHandler
        v-if="isEnableDocOutSelectHandlerDialog"
        :isOpen="isOpenDocOutSelectHandlerDialog"
        :outgoingProcessId="userVbOutgoingProcessId"
        :quote="outgoingDoc.quote"
        @closeDialog="isOpenDocOutSelectHandlerDialog = false"
        @closed="isEnableDocOutSelectHandlerDialog = false"
        @success="chuyenXuLiSuccess"
      />

      <!-- dialog ket thuc -->
      <DocOutKetThuc
        v-if="isEnableDocOutKetThucDialog"
        :docId="id"
        :isOpen="isOpenDocOutKetThucDialog"
        :vbOutgoingProcessId="userVbOutgoingProcessId"
        @closeDialog="isOpenDocOutKetThucDialog = false"
        @dialogClosed="isEnableDocOutKetThucDialog = false"
        @success="banHanhSuccess"
      />

      <outgoingDocThuHoiDialog
        v-if="isEnableOutgoingDocThuHoiDialog"
        :isOpen="isOpenOutgoingDocThuHoiDialog"
        :vbOutgoingDocId="id"
        @closeDialog="isOpenOutgoingDocThuHoiDialog = false"
        @dialogClosed="isEnableOutgoingDocThuHoiDialog = false"
      />
      <!-- dialog tu choi -->

      <DocOutTuChoi
        v-if="isEnableDocOutTuChoiDialog"
        :docId="id"
        :isOpen="isOpenDocOutTuChoiDialog"
        :listImageChange="listImageChange"
        :outgoingProcessId="userVbOutgoingProcessId"
        @closeDialog="isOpenDocOutTuChoiDialog = false"
        @closed="isEnableDocOutTuChoiDialog = false"
        @tuChoiSuccess="tuChoiSuccess"
      />
      <!-- dialog tu choi -->

      <DocOutTuChoiBanHanh
        v-if="isEnableDocOutTuChoiBHanhDialog"
        :docId="id"
        :isOpen="isOpenDocOutTuChoiBHanhDialog"
        @closeDialog="isOpenDocOutTuChoiBHanhDialog = false"
        @closed="isEnableDocOutTuChoiBHanhDialog = false"
        @tuChoiSuccess="tuChoiBHanhSuccess"
      />

      <!-- ban hành văn bản -->
      <BHanhDocOutDialog
        v-if="isEnableBHanhDocOut"
        :deptEditorId="outgoingDoc.deptEditorId"
        :docId="id"
        :docReceiverIds="docReceiverIds"
        :docStatus="outgoingDoc.status"
        :docTypeId="outgoingDoc.docTypeId"
        :isOpen="isOpenBHanhDocOut"
        :otherReceivePlaces="outgoingDoc.otherReceivePlaces"
        :publisherId="outgoingDoc.publisherId"
        :quote="outgoingDoc.quote"
        @closeDialog="isOpenBHanhDocOut = false"
        @closed="isEnableBHanhDocOut = false"
        @success="banHanhVanThuSuccess"
      />

      <!-- CC văn bản -->
      <CCDocOut
        v-if="isEnableDocOutCCDialog"
        :docId="id"
        :docTitle="outgoingDoc.quote"
        :isOpen="isOpenDocOutCCDialog"
        @closeDialog="isOpenDocOutCCDialog = false"
        @closed="isEnableDocOutCCDialog = false"
        @success="ccSuccess"
      />

      <outgoingDocProcessThuHoiDialog
        v-if="isEnableOutgoingDocProcessThuHoiDialog"
        :isOpen="isOpenOutgoingDocProcessThuHoiDialog"
        :vbOutgoingProcessId="userVbOutgoingProcessId"
        @closeDialog="isOpenOutgoingDocProcessThuHoiDialog = false"
        @dialogClosed="isEnableOutgoingDocProcessThuHoiDialog = false"
        @success="outGoingProcessThuHoiSuccess"
      />

      <outgoingDocThuHoiDialog
        v-if="isEnableOutgoingDocThuHoiDialog"
        :isOpen="isOpenOutgoingDocThuHoiDialog"
        :vbOutgoingDocId="id"
        @closeDialog="isOpenOutgoingDocThuHoiDialog = false"
        @dialogClosed="isEnableOutgoingDocThuHoiDialog = false"
      />

      <outgoingDocDBHThuHoiDialog
        v-if="isEnableOutgoingDocDBHThuHoiDialog"
        :isOpen="isOpenOutgoingDocDBHThuHoiDialog"
        :vbOutgoingDocId="id"
        @closeDialog="isOpenOutgoingDocDBHThuHoiDialog = false"
        @closed="isEnableOutgoingDocDBHThuHoiDialog = false"
      />
      <!--note in doc-->
      <DialogNoteInDocs
        v-if="isOpenNoteInDocDialog"
        :docId="id"
        :isAddSignature="false"
        :isOpen="isOpenNoteInDocDialog"
        :isWatchingNote="false"
        :vbAttachmentId="vbAttachment.id"
        @closeDialog="isOpenNoteInDocDialog = false"
        @closed="isEnableNoteInDocDialog = false"
        @finishNoteDoc="finishNoteDoc"
      />
      <!--add chu ky-->
      <DialogNoteInDocs
        v-if="isOpenAddSignatureDialog"
        :docId="id"
        :isAddSignature="true"
        :isOpen="isOpenAddSignatureDialog"
        :isWatchingNote="false"
        :vbAttachmentId="vbAttachment.id"
        @addSignatureSuccess="addSignatureSuccess"
        @closeDialog="isOpenAddSignatureDialog = false"
        @closed="isEnableAddSignatureDialog = false"
      />

      <task-create-dialog
        v-if="isEnableCreateJobDialog"
        :docId="id"
        :docType="DOC_TYPE.VB_DI"
        :isOpen="isOpenCreateJobDialog"
        :taskType="TASK_TASK_TYPE.GIAOVIEC"
        :viewType="JOB_INDEX_PAGE.ASSIGNER"
        @closeDialog="isOpenCreateJobDialog = false"
        @dialogClosed="isEnableCreateJobDialog = false"
        @success="createTaskSuccess"
      />

      <vb-outgoing-doc-sua-sai-bh-dialog
        v-if="isEnableSuaSaiDialog"
        :id="id"
        :isOpen="isOpenSuaSaiDialog"
        @closeDialog="isOpenSuaSaiDialog = false"
        @dialogClosed="isEnableSuaSaiDialog = false"
        @updateSuccess="suaSaiSuccess"
      >
      </vb-outgoing-doc-sua-sai-bh-dialog>
      <!--    hoang  cây thư mục start-->
      <tree-folder-dialog
        v-if="isEnableTreeFolderDialog"
        :accessoryType="accessoryType"
        :isOpen="isOpenDialogCreate"
        :vbId="id"
        @closeDialog="closeTreeFolderDialog"
        @closed="isEnableTreeFolderDialog"
        @success="createSuccess"
      />
      <!--   hoang   cây thư mục end-->
      <vbdi-list-version-dialog
        :docId="id"
        :isOpen="isOpenVbDiVersionDialog"
        :isConfigLD="true"
        :mode="mode"
        :title="'Phiên bản văn bản soạn thảo'"
        @closeDialog="isOpenVbDiVersionDialog=false"
      >
      </vbdi-list-version-dialog>
    </template>
  </detailTemplate>
</template>
<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import constants from "../../constants";
import {EventBus} from "../../event-bus.js";
import buildAttachmentURL from "../../filters/buildAttachmentURL.js";
import convertToLabelFilter from "../../filters/convertToLabelFilter";
import dateFormatter from "../../filters/dateFormatter";
import errorMessageFilter from "../../filters/errorMessageFilter";
import vbAttachmentTokenMixin from "../../mixins/vbAttachmentTokenMixin";
import attachmentService from "../../services/attachmentService";
import categoryViewService from "../../services/categoryViewService";
import docRelationService from "../../services/docRelationService";
import h from "../../services/h";
import menuConfigService from "../../services/menuConfigService";
import outgoingDocService from "../../services/outgoingDocService";
import utils from "../../services/utils";
import vbAttachmentTokenService from "../../services/vbAttachmentTokenService";
import vbDelegateInfoService from "../../services/vbDelegateInfoService";
import vbFlowInstanceService from "../../services/vbFlowInstanceService.js";
import vbOutgoingDocReceiversService from "../../services/vbOutgoingDocReceiversService";
import vbOutgoingProcessService from "../../services/vbOutgoingProcessService.js";
import vbStepService from "../../services/vbStepService";
import BreakWordSpan from "../adminstration/ketluan/break-word-span";
import FileTypeImage from "../common/FileTypeImage";
import handleRequestErrorMixin from "../handleRequestErrorMixin";
import TaskCreateDialog from "../job/create-job/task-create-dialog";
import BHanhDocOutDialog from "./components/BHanhDocOutDialog";
import CCDocOut from "./components/CCDocOut";
import DocOutKetThuc from "./components/DocOutKetThuc";
import DocOutTuChoi from "./components/DocOutTuChoi";
import DocOutTuChoiBanHanh from "./components/DocOutTuChoiBHanh";
import DocRelationsDetail from "./doc-relations-detail";
import HistoryDocout from "./History";
import PhieuYKienDetail from "./phieu-ykien-detail";
import VbOutgoingDocSuaSaiBhDialog from "./vb-outgoing-doc-sua-sai-bh-dialog";
import VbdiDownloadFilesForConfigLd from "./vbdi-download-files-for-config-ld";
import VbdiLuongxulyWrapper from "./vbdi-luongxuly-wrapper";
import CreateJobDialog from "../job/create-job/dialog-create";
import VbdiListVersionDialog from "./vbdi-list-version-dialog";
import VbdiLuongxulyAll from "../doc-out/vbdi-luongxuly-all.vue";

export default {
  mixins: [handleRequestErrorMixin, vbAttachmentTokenMixin],
  components: {
    VbdiListVersionDialog,
    VbdiLuongxulyAll,
    BreakWordSpan,
    VbOutgoingDocSuaSaiBhDialog,
    TaskCreateDialog,
    HistoryDocout,
    VbdiLuongxulyWrapper,
    DocRelationsDetail,
    PhieuYKienDetail,
    VbdiDownloadFilesForConfigLd,
    CreateJobDialog,
    FileTypeImage,
    DocOutSelectHandler: () => import("./components/DocOutSelectHandler.vue"),
    DocOutKetThuc,
    DocOutTuChoi,
    DocOutTuChoiBanHanh,
    BHanhDocOutDialog,
    CCDocOut,
    detailTemplate: () => import("../common/detail.vue"),
    outgoingDocProcessThuHoiDialog: () =>
      import("./components/outgoingDocProcessThuHoiDialog"),
    outgoingDocThuHoiDialog: () =>
      import("./components/outgoingDocThuHoiDialog"),
    outgoingDocDBHThuHoiDialog: () =>
      import("./components/thuhoiBanHanhdialog"),
    VuePerfectScrollbar,
    listIconAction: () => import("./components/listIconActionDocs.vue"),
    DialogNoteInDocs: () => import("../common/noteDocs/index"),
    treeFolderDialog: () => import("../setting/quanLyTaiLieu/treeFolderDialog")
  },

  filters: {dateFormatter, buildAttachmentURL, convertToLabelFilter},

  data() {
    return {
      // h- start
      mode: 'View',
      isOpenVbDiVersionDialog: false,
      // vbIngoingDocCopy: null,
      // vbOutgoingDocCopy: null,
      isOpenDialogCreate: false,
      isEnableTreeFolderDialog: true,
      accessoryType: constants.QUAN_LY_TAI_LIEU.VB_DI,
      vbId: null,
      vbType: null,
      steeringTypeLabel: null,
      isLawDocument: null,
      DOC_RELATION_ATTACHED_TYPE: constants.DOC_RELATION_ATTACHED_TYPE,
      DOC_RELATION_OBJECT_TYPE: constants.DOC_RELATION_OBJECT_TYPE,
      listImageChange: [],

      isOpenNoteInDocDialog: false,
      isEnableNoteInDocDialog: false,

      isOpenAddSignatureDialog: false,
      isEnableAddSignatureDialog: false,

      DOWNLOAD_OPTION: constants.DOWNLOAD_OPTION,
      settings: {maxScrollbarLength: 750},
      tabHistory: true,
      docRelationTypes: [],

      outgoingDoc: {},
      vbAttachment: {},
      attachmentMetadata: null,
      signatureFile: null,
      referenceOutgoingAttachment: null,
      docRelations: [],
      docReceivers: null,
      agencies: null,
      receiveOtherDepts: null,
      docReceiverIds: [],
      vbCommentObjectType: constants.COMMENT_OBJECT_TYPE.VB_DI,
      userVbOutgoingProcess: null,
      flowInstance: null,
      flowInstanceId: null,
      flowInstances: [],
      flowId: null,
      stepId: null,
      step: null,
      delegateInfo: null,

      isOpenDocOutSelectHandlerDialog: false,
      isEnableDocOutSelectHandlerDialog: false,
      isOpenDocOutKetThucDialog: false,
      isEnableDocOutKetThucDialog: false,

      isOpenDocOutTuChoiDialog: false,
      isEnableDocOutTuChoiDialog: false,

      isOpenDocOutTuChoiBHanhDialog: false,
      isEnableDocOutTuChoiBHanhDialog: false,

      isOpenDocOutCCDialog: false,
      isEnableDocOutCCDialog: false,

      isOpenOutgoingDocProcessThuHoiDialog: false,
      isEnableOutgoingDocProcessThuHoiDialog: false,
      isOpenOutgoingDocThuHoiDialog: false,
      isEnableOutgoingDocThuHoiDialog: false,
      isOpenOutgoingDocDBHThuHoiDialog: false,
      isEnableOutgoingDocDBHThuHoiDialog: false,
      isOpenBHanhDocOut: false,
      isEnableBHanhDocOut: false,
      outgoingAttachmentURL: null, //link download nguyen goc;
      outgoingAttachmentForVanThuURL: null, //link download co chu ky khong co watermark;
      referenceOutgoingAttachmentURL: null, //link download co chu ky kem watermark;
      referenceOutgoingAttachmentURL2: null, //link download trc khi ban hanh co kem watermark;

      isOpenCreateJobDialog: false,
      isEnableCreateJobDialog: false,
      TASK_TASK_TYPE: constants.TASK_TASK_TYPE,
      JOB_INDEX_PAGE: constants.JOB_INDEX_PAGE,
      giaoViecMenuConfig: null,
      DOC_TYPE: constants.DOC_TYPE,
      OUTGOING_DOC_STATUS: constants.OUTGOING_DOC_STATUS,

      isOpenSuaSaiDialog: false,
      isEnableSuaSaiDialog: false,
      openFlowDetail: false
    };
  },

  computed: {

    signerName() {
      if (this.outgoingDoc) {
        return this.outgoingDoc.signerUserDeptRoleId
          ? `${this.outgoingDoc.signerName} (${
            this.outgoingDoc.signerPosName
          } ${this.outgoingDoc.signerDeptName})`
          : this.outgoingDoc.signerName;
      } else {
        return null;
      }
    },

    isKyNgoai() {
      return (
        this.outgoingDoc &&
        this.outgoingDoc.isKyNgoai === constants.OUTGOING_DOC.IS_KY_NGOAI.TRUE
      );
    },

    userVbOutgoingProcessId() {
      return this.$route.query.vbDocProcessId;
    },

    parentRoute() {
      return this.$route.path.split("/")[3];
    },

    userId() {
      return this.$store.getters.user.id;
    },

    roleCode() {
      return this.$store.getters.userDeptRole.roleCode;
    },

    deptId() {
      return this.$store.getters.userDeptRole.deptId;
    },

    publisherId() {
      return this.outgoingDoc ? this.outgoingDoc.publisherId : null;
    },

    id() {
      return this.$route.params.id;
    },
    docStatus() {
      return this.outgoingDoc ? this.outgoingDoc.status : null;
    },

    attachmenttURLForChuyenVien() {
      return [
        constants.OUTGOING_DOC_STATUS.CHO_BAN_HANH,
        constants.OUTGOING_DOC_STATUS.DABANHANH
      ].indexOf(this.docStatus)
        ? this.referenceOutgoingAttachmentURL ||
        this.referenceOutgoingAttachmentURL2
        : this.referenceOutgoingAttachmentURL2;
    },

    userDeptRoleId() {
      return this.$route.params.userDeptRoleId;
    },

    isViewAsUyQuyen() {
      return (
        this.delegateInfo &&
        this.delegateInfo.fromUserDeptRoleId == this.userDeptRoleId
      );
    },

    isBanHanhTrucLienThong() {
      return this.agencies && this.agencies.length;
    }
  },

  mounted() {
    EventBus.$on("hieuChinhSuccess", options => {
      this.loadDocInfo();
    });
  },

  watch: {
    userVbOutgoingProcessId(newValue) {
      if (newValue) {
        this.loadUserVbOutgoingProcess();
      } else {
        this.userVbOutgoingProcess = null;
        this.flowInstanceId = null;
        this.stepId = this.userVbOutgoingProcess.stepId;
        this.step = null;
        this.flowInstance = null;
        this.flowId = null;
      }

      this.buildOutgoingAttachmentURL();
    },

    isOpenOutgoingDocProcessThuHoiDialog(newValue) {
      newValue && (this.isEnableOutgoingDocProcessThuHoiDialog = newValue);
    },
    isOpenOutgoingDocThuHoiDialog(newValue) {
      newValue && (this.isEnableOutgoingDocThuHoiDialog = newValue);
    },
    isOpenOutgoingDocDBHThuHoiDialog(newValue) {
      newValue && (this.isEnableOutgoingDocDBHThuHoiDialog = newValue);
    },
    isOpenDocOutKetThucDialog(newValue) {
      newValue && (this.isEnableDocOutKetThucDialog = newValue);
    },
    isOpenBHanhDocOut(newValue) {
      newValue && (this.isEnableBHanhDocOut = newValue);
    },
    isOpenDocOutSelectHandlerDialog(newValue) {
      newValue && (this.isEnableDocOutSelectHandlerDialog = newValue);
    },
    isOpenDocOutCCDialog(newValue) {
      newValue && (this.isEnableDocOutCCDialog = newValue);
    },
    isOpenDocOutTuChoiDialog(newValue) {
      newValue && (this.isEnableDocOutTuChoiDialog = newValue);
    },
    isOpenDocOutTuChoiBHanhDialog(newValue) {
      newValue && (this.isEnableDocOutTuChoiBHanhDialog = newValue);
    },
    isOpenNoteInDocDialog(newValue) {
      newValue && (this.isEnableNoteInDocDialog = newValue);
    },
    isOpenAddSignatureDialog(newValue) {
      newValue && (this.isEnableAddSignatureDialog = newValue);
    },
    isOpenSuaSaiDialog(newValue) {
      newValue && (this.isEnableSuaSaiDialog = newValue);
    },
    vbAttachment(newValue) {
      this.buildOutgoingAttachmentURL();
      this.buildReferenceOutgoingAttachmentURL2();
      this.loadAttachmentMetadata();
    },
    referenceOutgoingAttachment() {
      this.buildReferenceOutgoingAttachmentURL();
      this.buildOutgoingAttachmentForVanThuURL();
    },
    id() {
      this.loadDocInfo();
      this.loadReferenceOutgoingAttachment();
    },
    isOpenCreateJobDialog(newValue) {
      newValue && (this.isEnableCreateJobDialog = newValue);
    }
  },

  created() {
    this.loadCategories();
    this.loadDocInfo();
    this.loadReferenceOutgoingAttachment();
    this.initForGiaoViecButton();
  },

  methods: {
    suaSaiSuccess(event) {
      this.isOpenSuaSaiDialog = false;
      this.backModel();
      EventBus.$emit(this.parentRoute, {});
    },

    initSteeringTypeLabel() {
      switch (this.outgoingDoc.steeringType) {
        case constants.STEERING_TYPE.KHONGPHAICHIDAO:
          this.steeringTypeLabel = errorMessageFilter({
            errorCode: "steeringType.label.khongphaichidao"
          });
          break;
        case constants.STEERING_TYPE.CHIDAO:
          this.steeringTypeLabel = errorMessageFilter({
            errorCode: "steeringType.label.chidao"
          });
          break;
        case constants.STEERING_TYPE.BAOCAOCHIDAO:
          this.steeringTypeLabel = errorMessageFilter({
            errorCode: "steeringType.label.baocaochidao"
          });
          break;
      }
    },

    delete_() {
      this.$confirm(
        `Bạn có muốn xóa văn bản "${this.outgoingDoc.quote}" ?`,
        "Thông báo",
        {
          confirmButtonText: "Xác nhận",
          cancelButtonText: "Hủy bỏ",
          type: "warning"
        }
      ).then(() => {
        outgoingDocService
          .deleteForVanThu(this.id)
          .then(() => {
            this.$message({
              message: "Xóa văn bản thành công",
              type: "success"
            });
            EventBus.$emit('loadCounting', '');
            this.commonAfterSuccess();
          })
          .catch(error => this.commonHandleRequestError(error));
      });
    },
    exportTiepNhanVanBanReport() {
      utils.exportReport(constants.REPORT.TIEPNHANVANBAN.REPORT_URL, {
        userDeptRoleId: this.userDeptRoleId,
        docId: this.id,
        docType: constants.DOC_TYPE.VB_DI
      });
    },

    initForGiaoViecButton() {
      return menuConfigService
        .findAll({
          userDeptRoleId: this.userDeptRoleId,
          menuCode: constants.MENU_LIST.CONGVIEC_GIAO,
          status: constants.MENU_CONFIG.STATUS.ACTIVE
        })
        .then(response => {
          let menuConfigs = response.data;
          return (this.giaoViecMenuConfig =
            menuConfigs && menuConfigs.length ? menuConfigs[0] : null);
        });
    },

    createTaskSuccess() {
      this.isOpenCreateJobDialog = false;
    },

    openGiaoViecDialog() {
      this.isOpenCreateJobDialog = true;
    },

    loadAttachmentMetadata() {
      if (this.vbAttachment && this.vbAttachment.id) {
        attachmentService
          .getAttachmentMetadata(this.vbAttachment.id)
          .then(response => {
            this.attachmentMetadata = response.data;
          });
      } else {
        this.attachmentMetadata = null;
      }
    },

    loadReferenceOutgoingAttachment() {
      attachmentService
        .findReferenceOutgoingAttachment(this.id)
        .then(response => (this.referenceOutgoingAttachment = response.data));
    },

    /**
     * link download cho chuyen vien sau khi ban hanh;
     */
    buildReferenceOutgoingAttachmentURL() {
      if (this.referenceOutgoingAttachment) {
        vbAttachmentTokenService
          .getTokenForReferenceOutgoingAttachmentForConfigLD(
            this.referenceOutgoingAttachment.id
          )
          .then(response => {
            let token = response.data.token;
            this.referenceOutgoingAttachmentURL = buildAttachmentURL(token, {
              downloadFileURL:
              constants.DOWNLOAD_FILE_URL.REFERENCE_OUTGOING_URL
            });
          });
      } else {
        this.referenceOutgoingAttachmentURL = null;
      }
    },

    buildReferenceOutgoingAttachmentURL2() {
      if (this.vbAttachment) {
        vbAttachmentTokenService
          .getTokenForConfigLD(this.vbAttachment.id)
          .then(response => {
            let token = response.data.token;
            this.referenceOutgoingAttachmentURL2 = buildAttachmentURL(token, {
              type: constants.DOWNLOAD_OPTION.TYPE.PDF,
              downloadFileURL: constants.DOWNLOAD_FILE_URL.OUTGOING_URL
            });
          });
      } else {
        this.referenceOutgoingAttachmentURL2 = null;
      }
    },

    /**
     * link download khong co watermark;
     */
    buildOutgoingAttachmentForVanThuURL() {
      if (this.referenceOutgoingAttachment) {
        vbAttachmentTokenService
          .getTokenForReferenceOutgoingAttachmentForConfigLD(
            this.referenceOutgoingAttachment.id
          )
          .then(response => {
            let token = response.data.token;
            this.outgoingAttachmentForVanThuURL = buildAttachmentURL(token, {
              type: constants.DOWNLOAD_OPTION.TYPE.ORIGINAL,
              downloadFileURL: constants.DOWNLOAD_FILE_URL.DEFAULT_URL
            });
          });
      } else {
        this.outgoingAttachmentForVanThuURL = null;
      }
    },

    /**
     * link download nguyen goc;
     */
    buildOutgoingAttachmentURL() {
      if (this.vbAttachment) {
        vbAttachmentTokenService
          .getTokenForConfigLD(this.vbAttachment.id)
          .then(response => {
            let token = response.data.token;
            this.outgoingAttachmentURL = buildAttachmentURL(token, {
              type: constants.DOWNLOAD_OPTION.TYPE.ORIGINAL,
              downloadFileURL: constants.DOWNLOAD_FILE_URL.DEFAULT_URL
            });
          });
      } else {
        this.outgoingAttachmentURL = null;
      }
    },

    addSignatureSuccess() {
      this.isOpenAddSignatureDialog = false;
      this.loadDocInfo();
      this.loadReferenceOutgoingAttachment();
    },

    populateListImageDoc(listImage) {
      let listImageModify = [];
      h.each(listImage, item => {
        if (item.isModify) {
          listImageModify.push({
            base64: item.base64,
            pageNumber: item.id,
            vbAttachmentId: this.vbAttachment.id
          });
        }
      });
      return listImageModify;
    },

    finishNoteDoc(listImage) {
      this.listImageChange = this.populateListImageDoc(listImage);
      this.tuChoi();
    },

    hieuChinhVb() {
      this.$router.push({
        name: "vbChoBanHanhHieuChinh",
        params: {
          userDeptRoleId: this.$route.params.userDeptRoleId,
          id: this.id
        },
        query: this.$route.query
      });
    },

    suaSaiBanHanh() {
      this.isOpenSuaSaiDialog = true;
    },

    loadVbFlowInstance() {
      vbFlowInstanceService
        .findAll(
          {docId: this.id},
          {page: 0, size: 10, sort: "updateTime,asc"}
        )
        .then(response => {
          this.flowInstances = response.data.map((item, index) => {
            return {
              id: item.id,
              updateTime: item.updateTime,
              isActive: index == response.data.length - 1
            };
          });
        });
    },

    outGoingProcessThuHoiSuccess() {
      this.isOpenOutgoingDocProcessThuHoiDialog = false;
    },

    openTabHistory() {
      this.tabHistory = true;
    },

    closeTabHistory() {
      this.tabHistory = false;
    },

    getRelationTypeLabel(relationType) {
      var docRelationType = h.find(
        this.docRelationTypes,
        docRelationType => docRelationType.id == relationType
      );

      return docRelationType ? docRelationType.categoryName : null;
    },

    loadCategories() {
      h.each([constants.CATEGORY_GROUP_CODE.DOC_RELATION_TYPE], item => {
        categoryViewService
          .findAll({groupCode: item}, {page: 0, size: 1000})
          .then(response => {
            switch (item) {
              case constants.CATEGORY_GROUP_CODE.DOC_RELATION_TYPE:
                return (this.docRelationTypes = response.data);
            }
          });
      });
    },

    openCCDialog() {
      this.isOpenDocOutCCDialog = true;
    },

    tuChoi() {
      this.isOpenDocOutTuChoiDialog = true;
    },

    tuChoiBHanh() {
      this.isOpenDocOutTuChoiBHanhDialog = true;
    },

    banHanhSuccess(event) {
      this.isOpenDocOutKetThucDialog = false;
      this.userVbOutgoingProcess = event.vbOutgoingProcess;
      this.backModel();
      EventBus.$emit(this.parentRoute, {});
    },

    tuChoiSuccess() {
      this.isOpenDocOutTuChoiDialog = false;
      this.isOpenNoteInDocDialog = false;
      this.backModel();
      EventBus.$emit(this.parentRoute, {});
    },

    tuChoiBHanhSuccess() {
      this.isOpenDocOutTuChoiBHanhDialog = false;
      this.backModel();
      EventBus.$emit(this.parentRoute, {});
    },

    banHanhVanThuSuccess() {
      this.isOpenBHanhDocOut = false;
      this.commonAfterSuccess();
    },

    ccSuccess() {
      this.isOpenDocOutCCDialog = false;
      this.backModel();
      this.commonAfterSuccess();
    },

    commonAfterSuccess() {
      EventBus.$emit(this.parentRoute, {});
      this.backModel();
    },

    docOutKetThucDialogClosed() {
      if (this.isBanHanhSuccess) {
        this.message(
          "Thông báo",
          "Ban hành văn bản thành công.",
          "success",
          4000
        );

        this.backModel();

        this.loadDocInfo();

        EventBus.$emit(this.parentRoute, {});
      }
    },

    docOutTuChoiDialogClosed() {
      if (this.isTuChoiSuccess) {
        this.message(
          "Thông báo",
          "Từ chối văn bản thành công.",
          "success",
          3000
        );

        this.backModel();

        this.loadDocInfo();

        EventBus.$emit(this.parentRoute, {});
      }
    },

    isTuChoi() {
      return this.outgoingDoc.status == constants.OUTGOING_DOC_STATUS.TU_CHOI;
    },

    isChoXuLy() {
      return (
        this.userVbOutgoingProcess &&
        this.userVbOutgoingProcess.status ==
        constants.OUTGOING_PROCESS_STATUS.CHO_XU_LY
      );
    },

    isTaoMoi() {
      return (
        this.outgoingDoc &&
        this.outgoingDoc.status == constants.OUTGOING_DOC_STATUS.TAOMOI
      );
    },

    isEnableThemChuKy() {
      return (
        this.roleCode == "vanthu" &&
        this.attachmentMetadata &&
        this.outgoingDoc &&
        (this.outgoingDoc.status ==
          constants.OUTGOING_DOC_STATUS.CHO_BAN_HANH ||
          this.outgoingDoc.status == constants.OUTGOING_DOC_STATUS.DABANHANH)
      );
    },

    chuyenXuLiSuccess() {
      this.isOpenDocOutSelectHandlerDialog = false;

      this.message(
        "Thông báo",
        this.step && this.step.signType == 2
          ? "Ký số và chuyển xử lý văn bản thành công "
          : "Chuyển xử lý văn bản thành công ",
        "success",
        4000
      );

      EventBus.$emit(this.parentRoute, {});
      this.backListPage();
    },

    loadDocReceivers_(objectType) {
      return vbOutgoingDocReceiversService
        .findAll(
          {docId: this.id, objectType: objectType},
          {sort: "objectType", page: 0, size: 1000}
        )
        .then(response => response.data);
    },

    loadDocReceivers() {
      return this.loadDocReceivers_(constants.RECEIVER_OBJECT_TYPE.DONVI).then(
        docReceivers => {
          this.docReceivers = docReceivers;
          this.docReceiverIds = h.collect(
            docReceivers,
            docReceiver => docReceiver.objectId
          );
        }
      );
    },

    loadAgencies() {
      return this.loadDocReceivers_(
        constants.RECEIVER_OBJECT_TYPE.DONVI_TRUCLIENTHONG
      ).then(agencies => (this.agencies = agencies));
    },

    loadReceiveOtherDepts() {
      return this.loadDocReceivers_(
        constants.RECEIVER_OBJECT_TYPE.DONVI_BENNGOAI
      ).then(docReceivers => (this.receiveOtherDepts = docReceivers));
    },

    loadUserVbOutgoingProcess() {
      if (this.userVbOutgoingProcessId) {
        vbOutgoingProcessService
          .findById(this.userVbOutgoingProcessId)
          .then(response => {
            this.userVbOutgoingProcess = response.data;
            this.flowInstanceId = this.userVbOutgoingProcess.flowInstanceId;
            this.stepId = this.userVbOutgoingProcess.stepId;
            vbStepService
              .findById(this.stepId)
              .then(response => (this.step = response.data));
            if (this.userVbOutgoingProcess.delegateInfoId) {
              vbDelegateInfoService
                .findById(this.userVbOutgoingProcess.delegateInfoId)
                .then(response => (this.delegateInfo = response.data));
            } else {
              this.delegateInfo = null;
            }
            vbFlowInstanceService
              .findById(this.flowInstanceId)
              .then(response => {
                this.flowInstance = response.data;
                this.flowId = this.flowInstance.flowId;
              });
            // this.markAsRead();
          });
      }
    },

    modelBack() {
      this.$router.back();
    },

    getSecurityClass(id) {
      return constants.HIGH_LEVELS_SECURITY_IDS.indexOf(id) != -1
        ? "lv1"
        : "lv4";
    },

    getPriorityClass(id) {
      return constants.HIGH_LEVELS_PIORITY_IDS.indexOf(id) != -1
        ? "lv1"
        : "lv4";
    },

    backModel() {
      this.$router.push({name: this.parentRoute, params: this.$route.params});
    },

    maskAsRead() {
      outgoingDocService
        .maskAsRead(this.id, this.userVbOutgoingProcessId)
        .catch(error => this.commonHandleRequestError(error));
    },

    loadDocInfo() {
      outgoingDocService
        .findByIdForConfigLD(this.id)
        .then(response => (this.outgoingDoc = response.data))
        .then(() => {
          this.isLawDocument =
            this.outgoingDoc.isLawDocument === constants.TRUE;
          this.initSteeringTypeLabel();
        })
        .then(() => this.maskAsRead());

      attachmentService
        .findAll({
          objectId: this.id,
          objectType: constants.ATTACHMENT_OBJECT_TYPE.VB_DI
        })
        .then(response => {
          if (response.data && response.data.length) {
            this.vbAttachment = response.data[0];
          }
        });

      attachmentService
        .findAll(
          {
            objectId: this.id,
            objectType:
            constants.ATTACHMENT_OBJECT_TYPE.FILE_BAN_HANH_CO_CHU_KY_PDF
          },
          {sort: "createTime,desc", page: 0, size: 1}
        )
        .then(response => {
          if (response.data && response.data.length) {
            this.signatureFile = response.data[0];
          } else this.signatureFile = null;
        });

      docRelationService.findAll({objectId: this.id}).then(response => {
        this.docRelations = response.data;
      });

      this.loadUserVbOutgoingProcess();
      this.loadDocReceivers();
      this.loadReceiveOtherDepts();
      this.loadAgencies();
      this.loadVbFlowInstance();
    },

    backListPage() {
      let namePageBack = this.$route.path.split("/");
      this.$router.push({
        name: `${namePageBack[3]}`,
        query: this.$route.query,
        params: this.$route.params
      });
    },
    createSuccess() {
      this.isOpenDialogCreate = false;
    },
    closeCreateDialog() {
      this.isOpenDialogCreate = false;
    },
    closeTreeFolderDialog() {
      this.isEnableTreeFolderDialog = false
    },


  },

  destroyed() {
    EventBus.$off("hieuChinhSuccess");
    document.removeEventListener("keyup", this.escapeKeyListener);
  }
};
</script>

<style scoped>
.overflow-menu {
  position: relative;

  overflow-x: scroll;
  top: 4px;
  padding: 3px;
  margin: 3px;
}
</style>



// WEBPACK FOOTER //
// src/views/doc-out/vbDaVaoSoLDDetail.vue